import React, {useEffect, useState} from 'react'
import Logo from "../../../../../assets/images/logo.svg";
import {Link, useHistory} from "react-router-dom";
import {
  BUSINESS_DETAILS_STEP,
  COMPLETED_STEP,
  GENERAL_INFO_STEP,
  ROLE_STEP,
  SERVICES_STEP,
  STEPS
} from "./utils";
import {Role} from "./steps/role";
import {GeneralInfo} from "./steps/general_info";
import {BusinessDetails} from "./steps/business_details";
import {Services} from "./steps/services";
import {Completed} from "./steps/completed";
import {sendPhotographyAudit} from "../../../util/book_consultation_api_utils";
import {TestimonialsComponent2} from '../../home_page/homeComponents';
import footerImg from '../../../../../assets/images/./leadPages/footer-img.png'

const componentMap = {
  [ROLE_STEP]: Role,
  [BUSINESS_DETAILS_STEP]: BusinessDetails,
  [SERVICES_STEP]: Services,
  [GENERAL_INFO_STEP]: GeneralInfo,
  [COMPLETED_STEP]: Completed
}

export const PhotographyAudit = () => {
  const history = useHistory()
  const [step, setStep] = useState(ROLE_STEP)
  const [data, setData] = useState({})
  const StepComponent = componentMap[step]

  useEffect(() => {
    document.body.classList.add('position-relative')
    return () => {
      document.body.classList.remove('position-relative')
    }
  }, []);

  const onNext = (d) => {
    const newData = {...data, [step]: d}
    setData(newData)

    if (step === GENERAL_INFO_STEP) {
      const payload = Object.values(newData).reduce((res, fields) => {
        return {...res, ...fields}
      }, {})

      return sendPhotographyAudit(payload).then(() => {
        const stepIdx = STEPS.indexOf(step)
        setStep(STEPS[stepIdx + 1])
      })
    } else {
      const stepIdx = STEPS.indexOf(step)
      setStep(STEPS[stepIdx + 1])
    }
  }

  const onBack = () => {
    const stepIdx = STEPS.indexOf(step)
    setStep(STEPS[stepIdx - 1])
  }

  return <div className="apply-for-discount">
    <div className="schedule-demo-bg" style={{ pointerEvents: 'none' }}/>
    <div className="schedule-demo-container">
      {step === ROLE_STEP ? (
        <div className="initial-info-container title-container">
          <h1 style={{ marginBottom: '15px' }}>Let's talk about your next listing.</h1>
          <div className="apply-for-discount-initial-info-subtitle" style={{ marginBottom: '15px' }}>Fill out the form below and someone from our team will be in touch ASAP.</div>
          <div className="apply-for-discount-initial-info-title" style={{ marginBottom: '5px' }}>⭐⭐⭐⭐⭐ 100+ 5-Star Google Reviews</div>
          <div className="apply-for-discount-initial-info-title">Trusted by 2,000+ agents</div>
        </div>
      ) : (
        <div className="schedule-demo-logo">
          <Link to="/">
            <img className="modernAnglesLoginLogo" src={Logo} onClick={() => history.push("/")}/>
          </Link>
        </div>
      )}

      <div className="schedule-demo-form">
        <div className="schedule-demo-steps">
          {STEPS.map(s => (
            <div className={`schedule-demo-step ${s === step ? 'schedule-demo-step-active' : ''}`}
                 key={`step-${s}`}/>
          ))}
        </div>
        <StepComponent onNext={onNext} onBack={onBack} data={data[step]}/>
      </div>
    </div>

    <TestimonialsComponent2 bookPage={true}/>

    <div className="footer-container">
      <div className="apply-for-discount-footer-title">Instagram</div>
      <div className="apply-for-discount-footer-hashtag">
        <a href="https://www.instagram.com/modern.angles" target="_blank" style={{color: 'inherit', textDecoration: 'none'}}>@modern.angles</a>
      </div>
      <div className="apply-for-discount-footer-img">
        <img src={footerImg}/>
      </div>
    </div>
  </div>
}